module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit05-d59a20de6714fd8d931093c8b8365413.svg";